import { z } from 'zod';
import { CommonProcessPaymentFormSchema, ProcessPaymentFormField } from '../ProcessPaymentFormSchema';

export enum CashPaymentFormField {
    CashierId = 'cashierId',
}

export const cashPaymentFormSchema = CommonProcessPaymentFormSchema.extend({
    [ProcessPaymentFormField.Amount]: z.number(),
    [CashPaymentFormField.CashierId]: z.string(),
});

export type CashPaymentFormValues = z.infer<typeof cashPaymentFormSchema>;
